import Resource from './Resource';

export default class StudentInformation extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let config = {
			route: 'students/:student_rid/information',
			routeParams: routeParams,
			query: query,
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
